import { TimelineGroupData } from "../../mock/timeline";
import { Box } from "../Box";
import { Container } from "../Container";
import { FlexContainer } from "../Flex";
import { SuperText } from "../SuperText";
import { ScrollTransform } from "../ScrollTransform";
import { TimelineItem } from "./TimelineItem";

interface TimelineGroupProps {
  timelineGroup: TimelineGroupData;
  active: boolean;
}

export const TimelineGroup: React.FC<TimelineGroupProps> = ({
  timelineGroup,
  active,
}) => {
  return (
    <>
      <Box position="relative" id={timelineGroup.id.toString()}>
        <Container>
          <Box>
            <FlexContainer
              justifyContent={
                timelineGroup.startPosition === "start"
                  ? "flex-start"
                  : "flex-end"
              }
            >
              <Box zIndex={3} position="relative">
                <ScrollTransform
                  moveFactor={timelineGroup.dateMoveFactor}
                  startOffset={timelineGroup.dateStartOffset}
                >
                  <SuperText color={timelineGroup.dateColor}>
                    {timelineGroup.startDate}
                  </SuperText>
                </ScrollTransform>
              </Box>
            </FlexContainer>
          </Box>
        </Container>
      </Box>
      <Box>
        <Container>
          {timelineGroup.timelineItems.map((timelineItem) => (
            <TimelineItem
              groupActive={active}
              key={timelineItem.id}
              timelineItem={timelineItem}
            />
          ))}
        </Container>
      </Box>
    </>
  );
};
